import {
  MapMarkerDisplayType,
  MapMarkerDisplayTypeEnum,
} from "@/custom-types/StoreLocator";

export const HOVER_Z_INDEX_BOOST = 1000;

export const MARKER_LAYERS = {
  [MapMarkerDisplayTypeEnum.Icon]: 100,
  [MapMarkerDisplayTypeEnum.ProminentIcon]: 200,
  [MapMarkerDisplayTypeEnum.ImageContainer]: 300,
  [MapMarkerDisplayTypeEnum.ProminentImageContainer]: 400,
};

/**
 * Calculates the hovered and non-hovered z-index of a map marker based on
 * its display type first, then store's index in the results array.
 */
export function computeZIndexes(
  displayType: MapMarkerDisplayType,
  storeIdx: number,
) {
  const baseZIndex = MARKER_LAYERS[displayType];

  return {
    hovered: baseZIndex + HOVER_Z_INDEX_BOOST,
    notHovered: baseZIndex - storeIdx,
  };
}
